import { render } from "./InputYesNo.vue?vue&type=template&id=3bb4cca8&scoped=true"
import script from "./InputYesNo.vue?vue&type=script&lang=js"
export * from "./InputYesNo.vue?vue&type=script&lang=js"

import "./InputYesNo.vue?vue&type=style&index=0&id=3bb4cca8&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb4cca8"]])

export default __exports__